/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
import { ParsedParagraph, ParsedMediaImage } from './types_and_parser/types'
import {
  Block,
  FeaturedContentBlock,
  TextImageBlock,
  TextBlock,
  TextReadMoreBlock,
  CtaBlock,
  QuoteBlock,
  ExpandBlock,
  LinkListBlock,
  DownloadBlock,
  LinkGridBlock,
  LinkGridBlockPlain,
  MediaBlock,
  ImageGalleryBlock,
  IframeBlock,
  TextBlockNested,
  QuoteBlockNested,
  MediaBlockNested
} from './types_and_parser/standard_blocks.gen'
import { BlockData, textBlockNestedData, mediaBlockNestedData, quoteBlockNestedData } from '../cms/blocks/types.gen'
import { mk_pair, Option, some, none } from 'widgets-for-react'
import { TextImageBlockProps, TextImageBlockStyle } from '../cms/blocks/widgets/textImageBlock.gen'
import { buttonWrapper, parseLinkProps, linkWrapper } from '../cms/blocks/utils.gen'
import {
  textImageClasses,
  textBlockClasses,
  ctaBlockClasses,
  quoteBlockClasses,
  expandBlockClasses,
  linkListBlockClasses,
  downloadBlockClasses,
  linkGridBlockClasses,
  linkGridBlockPlainClasses,
  mediaBlockClasses,
  imageGalleryBlockClasses,
  iframeBlockClasses,
  textBlockNestedClasses,
  quoteBlockNestedClasses,
  mediaBlockNestedClasses
} from '../public_site/blocks/style.mod'
import { TextBlockProps, TextBlockStyle } from '../cms/blocks/widgets/textBlock.gen'
import { TextReadMoreBlockProps, TextReadMoreBlockStyle } from '../cms/blocks/widgets/textReadMoreBlock.gen'
import { CtaBlockProps, CtaBlockStyle } from '../cms/blocks/widgets/ctaBlock.gen'
import { QuoteBlockProps, QuoteBlockStyle } from '../cms/blocks/widgets/quoteBlock.gen'
import { ExpandBlockProps, ExpandBlockStyle, ExpandProps } from '../cms/blocks/widgets/expandBlock.gen'
import { LinkBlockProps, LinkBlockStyle, LinkProps } from '../cms/blocks/widgets/linkBlock.gen'
import { DownloadBlockProps, DownloadBlockStyle, DownloadProps } from '../cms/blocks/widgets/downloadBlock.gen'
import { LinkGridBlockProps, LinkGridBlockStyle, LinkGridItem } from '../cms/blocks/widgets/linkGridBlock.gen'
import { MediaBlockProps, MediaBlockStyle, MediaItem } from '../cms/blocks/widgets/mediaBlock.gen'
import {
  ImageGalleryBlockProps,
  ImageGalleryBlockStyle,
  ListWithAtLeast3Items,
  ImageGalleryImageProps
} from '../cms/blocks/widgets/imageGalleryBlock.gen'
import { IframeBlockProps, IframeBlockStyle } from '../cms/blocks/widgets/iframeBlock.gen'
import { TextBlockNestedProps, TextBlockNestedStyle } from '../cms/blocks/widgets/textBlockNested.gen'
import { QuoteBlockNestedProps, QuoteBlockNestedStyle } from '../cms/blocks/widgets/quoteBlockNested.gen'
import {
  MediaBlockNestedProps,
  MediaBlockNestedStyle,
  MediaItemNestedProps
} from '../cms/blocks/widgets/mediaBlockNested.gen'
import * as UriJs from 'uri-js'
import {
  ExtraImages,
  get_default_data_src,
  get_default_data_srcset,
  featuredblock_src,
  featuredblock_srcset,
  ctablock_src,
  ctablock_srcset,
  quoteblock_src,
  quoteblock_srcset,
  linkgridblock_src,
  linkgridblock_srcset,
  mediablock_src,
  mediablock_srcset,
  gallery_src,
  gallery_srcset
} from '../public_site/utils/extra_images.mod'
import { GetCookiebarContent, GetCookiebarButton } from './rendering/cookiebar_utils.mod'
import { List } from 'immutable'
import { CustomBlock } from './types_and_parser/custom_blocks.mod'
import { titleSplit } from '../public_site/utils/helpers'
import { t } from 'i18next'

export const TransformStandardBlock = (b: ParsedParagraph): Block => {
  // @ts-ignore
  return { ...b, kind: b.bundle }
}

export type CustomPageData = {}

// tslint:disable-next-line:variable-name
export const DrupalBlock_To_WidgetBlock = <
  CustomBlockData extends { kind: CustomBlockData['kind'] },
  CustomBlocks extends { kind: CustomBlocks['kind'] },
  CustomPageData
>(
  block: Block,
  index: number,
  extra_data: CustomPageData,
  mk_block?: (block: CustomBlocks, block_index: number, extra_data: CustomPageData) => Option<CustomBlockData>
): Option<BlockData<CustomBlockData, ExtraImages> | CustomBlockData> => {
  if (mk_block) {
    const maybe_res = mk_block(block as any, index, extra_data)
    if (maybe_res.v.kind == 'r') return maybe_res
  }
  switch (block.kind) {
    case 'text':
      return some<BlockData<CustomBlockData, ExtraImages>>(textBlock(block, index))
    case 'text_nested':
      return some<BlockData<CustomBlockData, ExtraImages>>(textBlockNested(block, index))
    case 'text_with_read_more':
      return some<BlockData<CustomBlockData, ExtraImages>>(
        textReadMoreBlock<CustomBlockData, CustomBlocks>(block, index)
      )
    case 'cta':
      return some<BlockData<CustomBlockData, ExtraImages>>(ctaBlock(block, index))
    case 'downloads':
      return some<BlockData<CustomBlockData, ExtraImages>>(downloadBlock(block, index))
    case 'links_list':
      return some<BlockData<CustomBlockData, ExtraImages>>(linkListBlock(block, index))
    case 'grid_blocks_plain':
      return some<BlockData<CustomBlockData, ExtraImages>>(linkGridBlockPlain(block, index))
    case 'quote_nested':
      return some<BlockData<CustomBlockData, ExtraImages>>(quoteBlockNested(block, index))
    case 'grid_blocks_image':
      return some<BlockData<CustomBlockData, ExtraImages>>(linkGridBlock(block, index))
    case 'media':
      return some<BlockData<CustomBlockData, ExtraImages>>(mediaBlock(block, index))
    case 'expandable_content_blocks':
      return some<BlockData<CustomBlockData, ExtraImages>>(expandBlock<CustomBlockData, CustomBlocks>(block, index))
    case 'image_gallery':
      return some<BlockData<CustomBlockData, ExtraImages>>(imageGalleryBlock(block, index))
    case 'iframe':
      return some<BlockData<CustomBlockData, ExtraImages>>(iframeBlock(block, index))
    default: {
      console.warn('Unsupported block.', block)
      return none<BlockData<CustomBlockData, ExtraImages> | CustomBlockData>()
    }
  }
}

export const parseImage = (i: ParsedMediaImage | undefined): number =>
  i != undefined &&
  i.field_media_image != undefined &&
  i.field_media_image.image != undefined &&
  i.field_media_image.image.id != null
    ? i.field_media_image.image.id
    : 0

export const textImage = <CustomBlocks>(
  block: TextImageBlock,
  index: number
): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'textImageBlock',
  value: mk_pair<TextImageBlockProps<CustomBlocks, ExtraImages>, TextImageBlockStyle>(
    {
      index: index,
      image: block.field_image ? parseImage(block.field_image) : 0,
      imageLocation: block.field_featured_content_direction == 'image_left' ? 'left' : 'right',
      title: block.field_title ? block.field_title : '',
      text: block.field_body,
      label: block.field_label,
      image_size: 'large',
      image_alt_text:
        block.field_image && block.field_image.field_media_image.alt ? block.field_image.field_media_image.alt : '',
      primary_button: block.field_links.isEmpty() ? undefined : buttonWrapper(block.field_links.first()),
      secondary_button:
        block.field_links.isEmpty() || block.field_links.count() <= 1
          ? undefined
          : buttonWrapper(block.field_links.last()),
      link_type: false,
      get_default_data_src: get_default_data_src,
      get_default_data_srcset: get_default_data_srcset,
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    },
    textImageClasses(block.field_featured_content_direction == 'image_left' ? 'left' : 'right')
  )
})

export const parseMediaUrl = (s: string) => {
  const uri = UriJs.parse(s)
  return `/drupal/media${uri.path}` + (uri.query ? `?${uri.query}` : '')
}

export const textBlock = <CustomBlocks>(block: TextBlock, index: number): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'textBlock',
  value: mk_pair<TextBlockProps<CustomBlocks, ExtraImages>, TextBlockStyle>(
    {
      index: index,
      primary_button: block.field_links.isEmpty() ? undefined : buttonWrapper(block.field_links.first()),
      link:
        block.field_links.isEmpty() || block.field_links.count() <= 1
          ? undefined
          : linkWrapper(block.field_links.last()),
      link_type: false,
      title: block.field_title ? titleSplit(block.field_title) : '',
      text: block.field_body,
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    },
    textBlockClasses
  )
})

export const textBlockNested = <CustomBlocks>(
  block: TextBlockNested,
  index: number
): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'textBlockNested',
  value: mk_pair<TextBlockNestedProps<CustomBlocks, ExtraImages>, TextBlockNestedStyle>(
    {
      index: index,
      text: block.field_body,
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    },
    textBlockNestedClasses
  )
})

export const textReadMoreBlock = <CustomBlockData extends { kind: CustomBlockData['kind'] }, CustomBlocks>(
  block: TextReadMoreBlock,
  index: number
): BlockData<CustomBlockData, ExtraImages> => ({
  kind: 'textReadMoreBlock',
  value: mk_pair<TextReadMoreBlockProps<CustomBlockData, ExtraImages>, TextReadMoreBlockStyle>(
    {
      index: index,
      title: block.field_title ? titleSplit(block.field_title) : '',
      text: block.field_body,
      open: false,
      readmore_blocks: List(block.field_read_more)
        .map(TransformStandardBlock)
        .map((b, i) => DrupalBlock_To_WidgetBlock<CustomBlockData, CustomBlock, CustomPageData>(b, i, {}))
        .map((b): BlockData<CustomBlockData, ExtraImages> | CustomBlockData => (b.v.kind === 'r' ? b.v.v : undefined))
        .map((b) => {
          if (b.kind === 'textBlockNested') {
            return b as textBlockNestedData<CustomBlockData, ExtraImages>
          }
          if (b.kind === 'mediaBlockNested') {
            return b as mediaBlockNestedData<ExtraImages>
          }
          if (b.kind === 'quoteBlockNested') {
            return b as quoteBlockNestedData<ExtraImages>
          }
          return undefined
        })
        .toList(),
      copy: {
        less: 'Read less',
        more: t('Common:ReadMore')
      },
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    },
    textBlockClasses
  )
})

export const ctaBlock = <CustomBlocks>(block: CtaBlock, index: number): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'ctaBlock',
  value: mk_pair<CtaBlockProps<ExtraImages>, CtaBlockStyle>(
    {
      index: index,
      title: block.field_title ? titleSplit(block.field_title) : '',
      intro: block.field_introduction,
      primary_button: block.field_link
        ? block.field_link && linkWrapper(block.field_link)
        : undefined,
      link_type: false,
      image: block.field_image ? parseImage(block.field_image) : undefined,
      image_alt:
        block.field_image && block.field_image.field_media_image.alt ? block.field_image.field_media_image.alt : '',
      image_size: '640w',
      get_default_data_src: ctablock_src,
      get_default_data_srcset: ctablock_srcset,
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    } as CtaBlockProps<ExtraImages>,
    ctaBlockClasses(block.field_image ? true : false)
  )
})

export const quoteBlockNested = <CustomBlocks>(
  block: QuoteBlockNested,
  index: number
): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'quoteBlockNested',
  value: mk_pair<QuoteBlockNestedProps<ExtraImages>, QuoteBlockNestedStyle>(
    {
      index: index,
      text: block.field_text,
      author: block.field_author_name ? block.field_author_name : '',
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    },
    quoteBlockNestedClasses
  )
})

export const expandBlock = <CustomBlockData extends { kind: CustomBlockData['kind'] }, CustomBlocks>(
  block: ExpandBlock,
  index: number
): BlockData<CustomBlockData, ExtraImages> => ({
  kind: 'expandBlock',
  value: mk_pair<ExpandBlockProps<CustomBlockData, ExtraImages>, ExpandBlockStyle>(
    {
      index: index,
      title: block.field_title ? titleSplit(block.field_title) : '',
      intro: block.field_introduction ? block.field_introduction : '',
      items: block.field_expandable_content_blocks
        .filter((x) => x !== undefined)
        .map<ExpandProps<CustomBlockData, ExtraImages>>((e, i) => ({
          key: `${index}-${i}`,
          index: index,
          title: e!.field_title,
          text: e!.field_body,
          open: false,
          useSVGIcons: true,
          blocks: List()
        }))
        .toArray(),
      link: block.field_link != undefined ? linkWrapper(block.field_link) : undefined,
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    },
    expandBlockClasses
  )
})

export const linkListBlock = <CustomBlocks>(
  block: LinkListBlock,
  index: number
): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'linkBlock',
  value: mk_pair<LinkBlockProps, LinkBlockStyle>(
    {
      index: index,
      title: block.field_title ? titleSplit(block.field_title) : '',
      intro: block.field_introduction ? block.field_introduction : '',
      items: block.field_links_list
        .filter((x) => x !== undefined)
        .map<LinkProps>((x, i) => parseLinkProps(x.field_url, "", i))
        .toArray(),
      useSVGIcons: false,
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    },
    linkListBlockClasses
  )
})

export const downloadBlock = <CustomBlocks>(
  block: DownloadBlock,
  index: number
): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'downloadBlock',
  value: mk_pair<DownloadBlockProps, DownloadBlockStyle>(
    {
      index: index,
      title: block.field_title ? titleSplit(block.field_title) : '',
      intro: block.field_introduction ? block.field_introduction : '',
      items: block.field_download_list
        .filter((x) => x !== undefined)
        .map<DownloadProps>((e, i) => ({
          key: `${e!.field_title} ${i}`,
          title: e!.field_title,
          file_url:
            e &&
            e.field_download &&
            e.field_download.field_media_file &&
            e.field_download.field_media_file.file &&
            e.field_download.field_media_file.file.url
              ? parseMediaUrl(e.field_download.field_media_file.file.url)
              : ''
        }))
        .toArray(),
      useSVGIcons: true,
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    },
    downloadBlockClasses
  )
})

export const linkGridBlock = <CustomBlocks>(
  block: LinkGridBlock,
  index: number
): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'linkGridBlock',
  value: mk_pair<LinkGridBlockProps<ExtraImages>, LinkGridBlockStyle>(
    {
      index: index,
      title: block.field_title ? titleSplit(block.field_title) : '',
      intro: block.field_introduction ? block.field_introduction : '',
      items: block.field_grid_blocks
        .filter((x) => x !== undefined)
        .map<LinkGridItem<ExtraImages>>((e) => ({
          ...e,
          image: parseImage(e!.field_image),
          image_size: 'grid',
          image_alt:
            e && e.field_image && e.field_image.field_media_image.alt ? e.field_image.field_media_image.alt : '',
          title: e && e.field_title ? titleSplit(e.field_title) : '',
          intro: e && e.field_introduction ? e.field_introduction : '',
          link:
            e && e.field_link && e.field_link.title && e.field_link.url != null ? linkWrapper(e.field_link) : undefined,
          show_image: block.kind == 'grid_blocks_image' ? 'yes' : 'no'
        }))
        .toArray(),
      link: block.field_link != undefined ? linkWrapper(block.field_link) : undefined,
      show_image: 'yes',
      get_default_data_src: linkgridblock_src,
      get_default_data_srcset: linkgridblock_srcset,
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    },
    linkGridBlockClasses
  )
})

export const linkGridBlockPlain = <CustomBlocks>(
  block: LinkGridBlockPlain,
  index: number
): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'linkGridBlock',
  value: mk_pair<LinkGridBlockProps<ExtraImages>, LinkGridBlockStyle>(
    {
      index: index,
      title: block.field_title ? titleSplit(block.field_title) : '',
      intro: block.field_introduction ? block.field_introduction : '',
      items: block.field_grid_blocks
        .map<LinkGridItem<ExtraImages>>((e) => ({
          ...e,
          image: 0,
          image_size: 'grid',
          image_alt: '',
          title: e && e.field_title ? titleSplit(e.field_title) : '',
          label: e && e.field_label ? e.field_label : '',
          intro: e && e.field_introduction ? e.field_introduction : '',
          link: e && e.field_link && e.field_link.title && e.field_link.url ? linkWrapper(e.field_link) : undefined,
          show_image: 'no'
        }))
        .toArray(),
      link: block.field_link != undefined ? linkWrapper(block.field_link) : undefined,
      show_image: 'yes',
      get_default_data_src: linkgridblock_src,
      get_default_data_srcset: linkgridblock_srcset,
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    },
    linkGridBlockPlainClasses
  )
})

export const mediaBlock = <CustomBlocks>(block: MediaBlock, index: number): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'mediaBlock',
  value: mk_pair<MediaBlockProps<ExtraImages>, MediaBlockStyle>(
    {
      index: index,
      items: null,
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    },
    mediaBlockClasses
  )
})

export const mediaBlockNested = <CustomBlocks>(
  block: MediaBlockNested,
  index: number
): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'mediaBlockNested',
  value: mk_pair<MediaBlockNestedProps<ExtraImages>, MediaBlockNestedStyle>(
    {
      index: index,
      items: block.field_media_item
        .map<MediaItemNestedProps<ExtraImages>>((e) => ({
          ...e,
          kind: e.field_media && e.field_media.bundle === 'image' ? 'image' : 'video',
          caption: e.field_image_caption ? e.field_image_caption : '',
          source: e.field_media && e.field_media.field_source ? e.field_media.field_source : '',
          image: e.field_media && e.field_media.bundle === 'image' ? parseImage(e.field_media) : 0,
          image_alt:
            e.field_media && e.field_media.bundle === 'image' && e.field_media.field_media_image.alt
              ? e.field_media.field_media_image.alt
              : '',
          size: '460w',
          get_default_data_src: mediablock_src,
          get_default_data_srcset: mediablock_srcset,
          video:
            e.field_media && e.field_media.bundle === 'video'
              ? {
                  url: e.field_media.field_media_video_embed_field.iframe_url,
                  id: e.field_media.field_media_video_embed_field.id,
                  type: e.field_media.field_media_video_embed_field.type,
                  allowFullScreen: true,
                  frameBorder: '0',
                  height: '345',
                  width: '460'
                }
              : undefined,
          useCookieBar: true,
          cookiePlaceholder: GetCookiebarContent('media'),
          cookieButton: GetCookiebarButton('media')
        }))
        .toArray(),
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    },
    mediaBlockNestedClasses
  )
})

export const imageGalleryBlock = <CustomBlocks>(
  block: ImageGalleryBlock,
  index: number
): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'imageGalleryBlock',
  value: mk_pair<ImageGalleryBlockProps<ExtraImages>, ImageGalleryBlockStyle>(
    {
      index: index,
      title: block.field_title ? titleSplit(block.field_title) : '',
      intro: block.field_introduction ? block.field_introduction : '',
      images: new ListWithAtLeast3Items(
        block.field_image_gallery
          .map<ImageGalleryImageProps<ExtraImages>>((e) => ({
            image: parseImage(e.field_image),
            image_alt: e.field_image.field_media_image.alt,
            image_size: '1280w',
            is_foreground: false,
            caption: e.field_image_caption ? e.field_image_caption : '',
            source: e.field_image && e.field_image.field_source ? e.field_image.field_source : '',
            index: index,
            imageDataSizes: '(min-width: 1280px) 1280px, 100vw'
          }))
          .toList()
      ),
      imagePreviewCount: 4,
      get_default_data_src: gallery_src,
      get_default_data_srcset: gallery_srcset,
      copy: {
        close: t('Common:ImageGallery.CloseOverlay'),
        more: t('Common:ImageGallery.MoreImages'),
        enlarged: t('Common:ImageGallery.EnlargedImage'),
        previous: t('Common:ImageGallery.PreviousImage'),
        next: t('Common:ImageGallery.NextImage')
      },
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    },
    imageGalleryBlockClasses
  )
})

export const iframeBlock = <CustomBlocks>(block: IframeBlock, index: number): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'iframeBlock',
  value: mk_pair<IframeBlockProps, IframeBlockStyle>(
    {
      index: index,
      link: block.field_link.url,
      useCookieBar: true,
      cookiePlaceholder: GetCookiebarContent('iframe'),
      cookieButton: GetCookiebarButton('iframe'),
      inview: {
        threshold: 0.1,
        triggerOnce: true
      }
    },
    iframeBlockClasses
  )
})
